var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortalBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layout_1_",
    "data-name": "layout (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.036,
    height: 15.036,
    viewBox: "0 0 15.036 15.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6411",
    "data-name": "Group 6411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6410",
    "data-name": "Group 6410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29592",
    "data-name": "Path 29592",
    d: "M2.761,0h-.7A2.058,2.058,0,0,0,0,2.056V12.98a2.058,2.058,0,0,0,2.056,2.056h.7A2.058,2.058,0,0,0,4.816,12.98V2.056A2.058,2.058,0,0,0,2.761,0Zm.881,12.98a.882.882,0,0,1-.881.881h-.7a.882.882,0,0,1-.881-.881V2.056a.882.882,0,0,1,.881-.881h.7a.882.882,0,0,1,.881.881Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29593",
    "data-name": "Path 29593",
    d: "M212.931,0h-4.875A2.058,2.058,0,0,0,206,2.056v.7a2.058,2.058,0,0,0,2.056,2.056h4.875a2.058,2.058,0,0,0,2.056-2.056v-.7A2.058,2.058,0,0,0,212.931,0Zm.881,2.761a.882.882,0,0,1-.881.881h-4.875a.882.882,0,0,1-.881-.881v-.7a.882.882,0,0,1,.881-.881h4.875a.882.882,0,0,1,.881.881Z",
    transform: "translate(-199.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29594",
    "data-name": "Path 29594",
    d: "M212.931,207h-4.875A2.058,2.058,0,0,0,206,209.056V213.9a2.058,2.058,0,0,0,2.056,2.056h4.875a2.058,2.058,0,0,0,2.056-2.056.587.587,0,0,0-1.175,0,.882.882,0,0,1-.881.881h-4.875a.882.882,0,0,1-.881-.881v-4.846a.882.882,0,0,1,.881-.881h4.875a.882.882,0,0,1,.881.881v1.909a.587.587,0,0,0,1.175,0v-1.909A2.058,2.058,0,0,0,212.931,207Z",
    transform: "translate(-199.95 -200.921)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalBuilder);
export default __webpack_public_path__ + "static/media/portal-builder.ed6307ba4627017fc157fa64f5c3a875.svg";
export { ForwardRef as ReactComponent };